import { Product } from '../Product';
import { CaseCreditorProduct } from '../Product/CaseCreditorProduct';
import { PaymentStatus } from '../Status/PaymentStatus';
import { Status } from '../Status/Status';
import { DialerList } from './DialerList';

export class DialerTrigger {
  id?: number;
  name: string;
  statusable_id?: number;
  statusable_type?: 'status' | 'payment_status' | 'call_status' | 'case_creditor_payment_status';
  dialer_list_id?: number;
  list_id: string;
  priority?: number;
  auto_queue?: 0 | 1 | boolean;
  active?: 0 | 1 | boolean;
  delay?: number;
  delay_unit?: 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month';
  force_dial: boolean;
  packager_id?: number;

  created_at: string | Date;
  updated_at: string | Date;

  // Relations
  statusable?: Status | PaymentStatus;
  products?: Array<Product>;
  case_creditor_products?: Array<CaseCreditorProduct>;

  // Helpers
  product_ids?: Array<number>;
  dialer_list?: DialerList;
}
